import { create } from 'zustand'

interface StockNoticeState {
	isOpen: boolean
	title: string
	message: string
	items: string[]
	removedFromBasket: boolean
	onClose: (() => void) | null
	show: (payload: {
		title: string
		message: string
		items: string[]
		removedFromBasket: boolean
		onClose?: () => void
	}) => void
	hide: () => void
}

const useStockNoticeStore = create<StockNoticeState>((set, get) => ({
	isOpen: false,
	title: '',
	message: '',
	items: [],
	removedFromBasket: false,
	onClose: null,
	show: ({ title, message, items, removedFromBasket, onClose }) =>
		set({
			isOpen: true,
			title,
			message,
			items,
			removedFromBasket,
			onClose: onClose || null,
		}),
	hide: () => {
		const { onClose } = get()
		if (onClose) {
			onClose()
		}
		set({
			isOpen: false,
			title: '',
			message: '',
			items: [],
			removedFromBasket: false,
			onClose: null,
		})
	},
}))

export default useStockNoticeStore
